module.exports = __webpack_public_path__ + "static/media/alarm.5f716f4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alarm.mp3
// module id = fKj8
// module chunks = 59